import React from "react";
import "./internships.css";

const Internships = () => {
  return (
    <div className="internships-container">
      <h1 className="internships-title">🎯 Internships</h1>

      <div className="internship-card">
        <h2>📨 Apply for Internships</h2>
        <p>
          Drop your internship application directly to our email:{" "}
          <a href="https://mail.google.com/mail/?view=cm&fs=1&to=internship@neelaverse.com" target="_blank" className="email-link">
            internship@neelaverse.com
          </a>
        </p>
        <p>
          For any queries, contact: <strong>+91-8121956868</strong>
        </p>
      </div>
    </div>
  );
};

export default Internships;
